<template>
  <div>
    <detail-content :slist="swiperList" :body="body" :img="img" :id="this.$route.params.id" v-transition></detail-content>
  </div>
</template>

<script>
import DetailContent from './components/Content'
export default {
  name: 'Detail',
  components: {
    DetailContent
  },
  data () {
    return {
      swiperList: [],
      body: {},
      img: ''
      // newcontent: {}
    }
  },
  methods: {
    getDetailInfo () {
      this.axios.get('/ApiDetail/GetModelTest', {
        params: {
          id: this.$route.params.id
        }// 获取id值并发送给后端
      }).then(this.getDetailInfoSucc)
        .catch(this.getDetailInfoFail)
    },
    getDetailInfoSucc (res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        this.swiperList = JSON.parse(data.swiperList)
        this.img = this.swiperList[0].imgUrl
        // var newbody = data.body.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '\'').replace(/&nbsp;/g, ' ')
        var newbody = data.body.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '\'').replace(/&nbsp;/g, ' ').replace(/\r/g, '\r').replace(/\n/g, '\n')
        this.body = JSON.parse(newbody)
        // this.newcontent = this.body.content.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '\'').replace(/&nbsp;/g, ' ').replace(/\r/g, '\r').replace(/\n/g, '\n')
        // console.log(this.body.content.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '\'').replace(/&nbsp;/g, ' ').replace(/\r/g, '\r').replace(/\n/g, '\n'))
        // this.body = this.evil('(' + newbody + ')')
      }
    },
    getDetailInfoFail (err) {
      // alert('获取数据失败')
      console.log(err)
    }
  },
  mounted () {
    this.getDetailInfo()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/detail/Detail.vue